var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"lmm-center-map\">\n    <div class=\"melia-icon "
    + container.escapeExpression(((helper = (helper = helpers.iconClassName || (depth0 != null ? depth0.iconClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"iconClassName","hash":{},"data":data}) : helper)))
    + "\"></div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/hotelLocation/hotelLocation.hbs
// module id = 132
// module chunks = 1